import React, { useState } from 'react';
import { FiSettings, FiSave, FiRefreshCw } from 'react-icons/fi';
import { toast } from 'react-toastify';
import './Configuracoes.css';

const Configuracoes = () => {
  const [configuracoes, setConfiguracoes] = useState({
    nomeIgreja: 'Igreja Evangélica',
    endereco: '',
    telefone: '',
    email: '',
    horarioReuniao: '19:00',
    diasReuniao: ['domingo', 'quarta'],
    notificacoes: true,
    backupAutomatico: true
  });

  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setConfiguracoes(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleDiaChange = (dia) => {
    setConfiguracoes(prev => ({
      ...prev,
      diasReuniao: prev.diasReuniao.includes(dia)
        ? prev.diasReuniao.filter(d => d !== dia)
        : [...prev.diasReuniao, dia]
    }));
  };

  const salvarConfiguracoes = async () => {
    try {
      setLoading(true);
      // Aqui você implementaria a chamada para a API
      await new Promise(resolve => setTimeout(resolve, 1000)); // Simulação
      toast.success('Configurações salvas com sucesso!');
    } catch (error) {
      console.error('Erro ao salvar configurações:', error);
      toast.error('Erro ao salvar configurações');
    } finally {
      setLoading(false);
    }
  };

  const diasSemana = [
    { value: 'domingo', label: 'Domingo' },
    { value: 'segunda', label: 'Segunda-feira' },
    { value: 'terca', label: 'Terça-feira' },
    { value: 'quarta', label: 'Quarta-feira' },
    { value: 'quinta', label: 'Quinta-feira' },
    { value: 'sexta', label: 'Sexta-feira' },
    { value: 'sabado', label: 'Sábado' }
  ];

  return (
    <div className="configuracoes-page">
      <div className="page-header">
        <div className="header-content">
          <h1>
            <FiSettings className="page-icon" />
            Configurações do Sistema
          </h1>
          <p>Configure as preferências e dados da congregação</p>
        </div>
      </div>

      <div className="configuracoes-container">
        <div className="config-section">
          <h2>Dados da Igreja</h2>
          <div className="form-grid">
            <div className="form-group">
              <label htmlFor="nomeIgreja">Nome da Igreja</label>
              <input
                type="text"
                id="nomeIgreja"
                name="nomeIgreja"
                value={configuracoes.nomeIgreja}
                onChange={handleInputChange}
                placeholder="Nome da congregação"
              />
            </div>

            <div className="form-group">
              <label htmlFor="endereco">Endereço</label>
              <input
                type="text"
                id="endereco"
                name="endereco"
                value={configuracoes.endereco}
                onChange={handleInputChange}
                placeholder="Endereço completo"
              />
            </div>

            <div className="form-group">
              <label htmlFor="telefone">Telefone</label>
              <input
                type="tel"
                id="telefone"
                name="telefone"
                value={configuracoes.telefone}
                onChange={handleInputChange}
                placeholder="(00) 00000-0000"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">E-mail</label>
              <input
                type="email"
                id="email"
                name="email"
                value={configuracoes.email}
                onChange={handleInputChange}
                placeholder="contato@igreja.com"
              />
            </div>
          </div>
        </div>

        <div className="config-section">
          <h2>Configurações de Reuniões</h2>
          <div className="form-grid">
            <div className="form-group">
              <label htmlFor="horarioReuniao">Horário Padrão das Reuniões</label>
              <input
                type="time"
                id="horarioReuniao"
                name="horarioReuniao"
                value={configuracoes.horarioReuniao}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group full-width">
              <label>Dias das Reuniões</label>
              <div className="checkbox-group">
                {diasSemana.map(dia => (
                  <label key={dia.value} className="checkbox-item">
                    <input
                      type="checkbox"
                      checked={configuracoes.diasReuniao.includes(dia.value)}
                      onChange={() => handleDiaChange(dia.value)}
                    />
                    <span>{dia.label}</span>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="config-section">
          <h2>Preferências do Sistema</h2>
          <div className="form-grid">
            <div className="form-group">
              <label className="switch-label">
                <input
                  type="checkbox"
                  name="notificacoes"
                  checked={configuracoes.notificacoes}
                  onChange={handleInputChange}
                />
                <span className="switch"></span>
                Receber notificações
              </label>
            </div>

            <div className="form-group">
              <label className="switch-label">
                <input
                  type="checkbox"
                  name="backupAutomatico"
                  checked={configuracoes.backupAutomatico}
                  onChange={handleInputChange}
                />
                <span className="switch"></span>
                Backup automático
              </label>
            </div>
          </div>
        </div>

        <div className="form-actions">
          <button
            type="button"
            className="btn-primary"
            onClick={salvarConfiguracoes}
            disabled={loading}
          >
            {loading ? (
              <>
                <FiRefreshCw className="spin" />
                Salvando...
              </>
            ) : (
              <>
                <FiSave />
                Salvar Configurações
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Configuracoes;